<template>
    <div class="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
        <div class="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
            <div class="flex items-center gap-2">
                <span class="w-8 h-8 rounded-xl bg-indigo-100 text-indigo-700 flex items-center justify-center">
                    <v-icon name="hi-solid-inbox-in" class="w-4 h-4" />
                </span>
                <div>
                    <p class="text-sm font-semibold text-slate-800 leading-none">{{ department.name }}</p>
                    <p class="text-xs text-slate-400 mt-0.5">Coda promemoria</p>
                </div>
            </div>

            <span
                class="inline-flex items-center justify-center min-w-[1.5rem] h-6 px-1.5 rounded-full text-xs font-bold"
                :class="queue.length > 0 ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-400'"
            >
                {{ queue.length }}
            </span>
        </div>

        <div class="divide-y divide-slate-100">
            <div
                v-if="queue.length === 0"
                class="px-4 py-6 flex flex-col items-center text-slate-300"
            >
                <v-icon name="hi-solid-check-circle" class="w-8 h-8 mb-1" />
                <p class="text-xs font-medium">Nessun promemoria in coda</p>
            </div>

            <div
                v-for="reminder in queue"
                :key="reminder.id"
                class="px-4 py-3 hover:bg-slate-50 transition-colors"
            >
                <div class="flex items-start justify-between gap-2">
                    <div class="flex-1 min-w-0">
                        <p class="text-sm font-medium text-slate-800 truncate">{{ reminder.title }}</p>
                        <p v-if="reminder.description" class="text-xs text-slate-400 mt-0.5 line-clamp-1">
                            {{ reminder.description }}
                        </p>
                        <div class="flex items-center gap-2 mt-1.5">
                            <span class="text-xs text-slate-400">
                                {{ reminder.creator?.name ?? '—' }}
                            </span>
                            <span class="text-slate-200">·</span>
                            <span class="text-xs text-slate-400">{{ formatDate(reminder.created_at) }}</span>
                        </div>
                    </div>

                    <button
                        @click="$emit('take', reminder)"
                        :disabled="takingId === reminder.id"
                        class="flex-shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                    >
                        <v-icon
                            :name="takingId === reminder.id ? 'hi-solid-refresh' : 'hi-solid-hand'"
                            class="w-3.5 h-3.5"
                            :class="{ 'animate-spin': takingId === reminder.id }"
                        />
                        In carico
                    </button>
                </div>
            </div>
        </div>

        <div v-if="queue.length > 0" class="px-4 py-2 border-t border-slate-100 bg-slate-50/60">
            <p class="text-xs text-slate-400 text-center">
                {{ queue.length }} {{ queue.length === 1 ? 'promemoria in attesa' : 'promemoria in attesa' }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DepartmentQueueWidget',

    emits: ['take'],

    props: {
        department: {
            type: Object,
            required: true,
        },
        queue: {
            type: Array,
            default: () => [],
        },
        takingId: {
            type: String,
            default: null,
        },
    },

    methods: {
        formatDate(value) {
            if (!value) return '—';
            return new Date(value).toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },
    },
};
</script>
